import axios from 'axios';
import Pagination from '@/domain/pagination.entity';

export default class AccessService {
  public static getAccesses(businessUnitId: string, pagination: Pagination): Promise<any> {
    return axios.get(`/api/v1/business-units/${businessUnitId}/accesses`, {
      params: {
        page: pagination.page - 1,
        size: pagination.itemsPerPage,
        sortBy: pagination.arrangeSortBy,
      },
    });
  }

  public static postAccess(businessUnitId: string, username: string): Promise<any> {
    return axios.post(`/api/v1/business-units/${businessUnitId}/accesses`, { username });
  }

  public static deleteAccess(accessId: string): Promise<any> {
    return axios.delete(`/api/v1/accesses/${accessId}`);
  }

  public static updateAccess(accessId: string, profile: string): Promise<void> {
    return axios.patch(`/api/v1/accesses/${accessId}/profile/${profile}`);
  }
}
